var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content album-list-page album-studio" },
    [
      _c("div", { staticClass: "page-header-card" }, [
        _vm._m(0),
        _c("div", { staticClass: "header-badges" }, [
          _c("div", { staticClass: "summary-badge" }, [
            _c("span", { staticClass: "summary-badge__label" }, [
              _vm._v("Tổng số album"),
            ]),
            _c("strong", { staticClass: "summary-badge__value" }, [
              _vm._v(_vm._s(_vm.total || 0)),
            ]),
          ]),
          _c("div", { staticClass: "summary-badge" }, [
            _c("span", { staticClass: "summary-badge__label" }, [
              _vm._v("Đang chọn"),
            ]),
            _c("strong", { staticClass: "summary-badge__value" }, [
              _vm._v(_vm._s(_vm.listIdApproveAlbum.length)),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "toolbar-card" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _vm._m(1),
            _c("el-date-picker", {
              staticClass: "toolbar-datepicker",
              attrs: {
                clearable: true,
                "value-format": "yyyy-MM-dd",
                format: "dd-MM-yyyy",
                type: "daterange",
                "unlink-panels": "",
                "range-separator": "→",
                "start-placeholder": "Ngày bắt đầu",
                "end-placeholder": "Ngày kết thúc",
                "aria-label": "Thời gian tạo album",
                "popper-class": "album-studio-popper",
              },
              on: {
                change: function ($event) {
                  return _vm.searchByProperties()
                },
              },
              model: {
                value: _vm.dataSearch.dateList,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "dateList", $$v)
                },
                expression: "dataSearch.dateList",
              },
            }),
            _vm.getAppTypeUserLogin === "plus"
              ? _c(
                  "el-select",
                  {
                    staticClass: "toolbar-select",
                    attrs: {
                      placeholder: "Loại album",
                      clearable: "",
                      "aria-label": "Lọc theo loại album",
                      "popper-class": "album-studio-popper",
                    },
                    on: { change: _vm.handleAlbumTypeChange },
                    model: {
                      value: _vm.dataSearch.albumType,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "albumType", $$v)
                      },
                      expression: "dataSearch.albumType",
                    },
                  },
                  _vm._l(_vm.albumTypesOption, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm.dataSearch.albumType === "CLASS"
              ? _c(
                  "el-select",
                  {
                    staticClass: "toolbar-select",
                    attrs: {
                      placeholder: "Chọn lớp",
                      clearable: "",
                      "aria-label": "Lọc theo lớp",
                      "popper-class": "album-studio-popper",
                    },
                    on: { change: _vm.searchHeaderMethod },
                    model: {
                      value: _vm.dataSearch.idClass,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "idClass", $$v)
                      },
                      expression: "dataSearch.idClass",
                    },
                  },
                  _vm._l(_vm.listClass, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.className, value: item.id },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm.getAppTypeUserLogin === "plus"
              ? _c(
                  "el-select",
                  {
                    staticClass: "toolbar-select",
                    attrs: {
                      placeholder: "Trạng thái",
                      clearable: "",
                      "aria-label": "Lọc theo trạng thái album",
                      "popper-class": "album-studio-popper",
                    },
                    on: { change: _vm.searchHeaderMethod },
                    model: {
                      value: _vm.dataSearch.approved,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "approved", $$v)
                      },
                      expression: "dataSearch.approved",
                    },
                  },
                  _vm._l(_vm.statusAlbum, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.checkPermission(["studentQuality_ablum_update"])
          ? _c(
              "div",
              { staticClass: "toolbar-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "cancel-link",
                    attrs: { to: { path: "/album-v2/add" } },
                  },
                  [
                    _c(
                      "Phase2ActionButton",
                      {
                        staticClass: "btn-action",
                        attrs: { type: "success", icon: "el-icon-plus" },
                      },
                      [_vm._v("\n          Tạo Album\n        ")]
                    ),
                  ],
                  1
                ),
                _c("Phase2Dropdown", {
                  attrs: {
                    label: "Tác vụ",
                    trigger: "click",
                    "popper-class": "album-studio-popper",
                    "button-type": "default",
                    "button-size": "",
                    "button-icon": "",
                    disabled: _vm.batchActionLoading,
                    loading: _vm.batchActionLoading,
                    items: _vm.taskActions,
                  },
                  on: { command: _vm.handleCommandAction },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.listLoading
        ? _c(
            "div",
            {
              staticClass: "album-list-skeleton",
              attrs: {
                role: "status",
                "aria-live": "polite",
                "aria-label": "Đang tải danh sách album",
              },
            },
            [
              _vm._l(6, function (number) {
                return _c(
                  "div",
                  { key: number, staticClass: "album-card-skeleton" },
                  [_c("div"), _c("span"), _c("span")]
                )
              }),
              _c("span", { staticClass: "album-sr-only" }, [
                _vm._v("Đang tải danh sách album…"),
              ]),
            ],
            2
          )
        : _vm.listError
        ? _c(
            "div",
            { staticClass: "empty-state", attrs: { role: "alert" } },
            [
              _c("i", {
                staticClass: "el-icon-warning-outline empty-state__icon",
              }),
              _c("div", { staticClass: "empty-state__title" }, [
                _vm._v("Không tải được danh sách album"),
              ]),
              _c("div", { staticClass: "empty-state__desc" }, [
                _vm._v("Vui lòng kiểm tra kết nối và thử lại."),
              ]),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.searchByProperties },
                },
                [_vm._v("Thử lại")]
              ),
            ],
            1
          )
        : _vm.total > 0
        ? _c("div", { staticClass: "grid-shell" }, [
            _c(
              "div",
              { staticClass: "select-bar" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.isCheckAll,
                      callback: function ($$v) {
                        _vm.isCheckAll = $$v
                      },
                      expression: "isCheckAll",
                    },
                  },
                  [_vm._v("\n        Chọn tất cả\n      ")]
                ),
                _vm.listIdApproveAlbum.length > 0
                  ? _c("span", { staticClass: "select-bar__count" }, [
                      _vm._v(
                        "\n        Đã chọn " +
                          _vm._s(_vm.listIdApproveAlbum.length) +
                          " album\n      "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "album-grid-viewport",
                attrs: {
                  role: "region",
                  "aria-label": "Danh sách album",
                  tabindex: "0",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "album-grid" },
                  _vm._l(_vm.albumResponseList, function (albumResponse) {
                    return _c(
                      "div",
                      {
                        key: albumResponse.albumIdx,
                        staticClass: "album-card",
                        class: {
                          "album-card--selected": albumResponse.checkApprove,
                        },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "album-card__cover-link",
                            attrs: {
                              to: {
                                path:
                                  "/album-v2/detail/" + albumResponse.albumIdx,
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "album-card__cover" },
                              [
                                albumResponse.albumNew ||
                                albumResponse.urlPictureFirst === null
                                  ? _c("TagFlag", { attrs: { title: "Mới" } })
                                  : _vm._e(),
                                albumResponse.urlShowPicture != null &&
                                !albumResponse.imageError
                                  ? _c(
                                      "el-image",
                                      {
                                        staticClass: "album-card__img",
                                        attrs: {
                                          src: albumResponse.urlShowPicture,
                                          fit: "cover",
                                        },
                                        on: {
                                          error: function ($event) {
                                            return _vm.handleAlbumImageError(
                                              albumResponse
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "album-card__image-loading",
                                            attrs: { slot: "placeholder" },
                                            slot: "placeholder",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-loading",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : albumResponse.imageLoading
                                  ? _c(
                                      "div",
                                      { staticClass: "album-card__no-img" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-loading album-card__no-img-icon",
                                        }),
                                        _c("span", [_vm._v("Đang tải ảnh")]),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "album-card__no-img" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-picture-outline album-card__no-img-icon",
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              albumResponse.imageError
                                                ? "Không tải được ảnh"
                                                : "Chưa có ảnh"
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                _c(
                                  "span",
                                  { staticClass: "album-card__cover-count" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _vm._v(
                                      _vm._s(albumResponse.pictureNumber) +
                                        " ảnh"
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "album-card__status-badge",
                                    class: albumResponse.albumApproved
                                      ? "badge--visible"
                                      : "badge--hidden",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          albumResponse.albumApproved
                                            ? "Đang hiện"
                                            : "Đã ẩn"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "album-card__info" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "album-card__name-link",
                                attrs: {
                                  to: {
                                    path:
                                      "/album-v2/detail/" +
                                      albumResponse.albumIdx,
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "album-card__name",
                                    attrs: {
                                      title:
                                        _vm.albumResponseAlbumName(
                                          albumResponse
                                        ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.albumResponseAlbumName(
                                            albumResponse
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "album-card__meta" }, [
                              albumResponse.className
                                ? _c(
                                    "span",
                                    { staticClass: "album-card__meta-item" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-office-building",
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(albumResponse.className) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              albumResponse.albumType
                                ? _c(
                                    "span",
                                    { staticClass: "album-card__meta-item" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-collection-tag",
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.albumTypeLabel(
                                              albumResponse.albumType
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "album-card__footer" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    key: albumResponse.albumIdx,
                                    attrs: {
                                      "aria-label":
                                        "Chọn album " + albumResponse.albumName,
                                    },
                                    on: {
                                      change: (val) =>
                                        _vm.checkApproveAlbum(
                                          albumResponse.albumIdx,
                                          val
                                        ),
                                    },
                                    model: {
                                      value: albumResponse.checkApprove,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          albumResponse,
                                          "checkApprove",
                                          $$v
                                        )
                                      },
                                      expression: "albumResponse.checkApprove",
                                    },
                                  },
                                  [_vm._v("Chọn")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "album-card__date" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDateTime")(
                                          albumResponse.createdDate
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "album-card__actions",
                                class: albumResponse.albumView
                                  ? "actions--visible"
                                  : "actions--hidden",
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass:
                                      "album-card__action-btn album-card__action-btn--download",
                                    attrs: {
                                      size: "mini",
                                      loading: albumResponse.checkDownload,
                                      icon: "el-icon-download",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.download1(albumResponse)
                                      },
                                    },
                                  },
                                  [_vm._v("Tải về")]
                                ),
                                _vm.checkPermission([
                                  "studentQuality_ablum_update",
                                ])
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass:
                                          "album-card__action-btn album-card__action-btn--danger",
                                        attrs: {
                                          size: "mini",
                                          icon: "el-icon-delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteAlbum(
                                              albumResponse.albumIdx
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Xóa")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            ),
          ])
        : _c(
            "div",
            { staticClass: "empty-state" },
            [
              _c("i", {
                staticClass: "el-icon-folder-opened empty-state__icon",
              }),
              _c("div", { staticClass: "empty-state__title" }, [
                _vm._v(
                  _vm._s(
                    _vm.hasAlbumFilters
                      ? "Không tìm thấy album phù hợp"
                      : "Chưa có album nào"
                  )
                ),
              ]),
              _c("div", { staticClass: "empty-state__desc" }, [
                _vm._v(
                  _vm._s(
                    _vm.hasAlbumFilters
                      ? "Thử thay đổi bộ lọc để xem các album khác."
                      : "Tạo album mới để bắt đầu lưu trữ hình ảnh của trường."
                  )
                ),
              ]),
              _vm.checkPermission(["studentQuality_ablum_update"])
                ? _c(
                    "router-link",
                    {
                      staticClass: "cancel-link",
                      attrs: { to: { path: "/album-v2/add" } },
                    },
                    [
                      _c(
                        "Phase2ActionButton",
                        {
                          staticClass: "btn-action",
                          attrs: { type: "success", icon: "el-icon-plus" },
                        },
                        [_vm._v("\n        Tạo Album\n      ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
      !_vm.listLoading && !_vm.listError && _vm.total > 0
        ? _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pageNumber,
                  "page-size": _vm.maxPageItem,
                  "page-sizes": _vm.listPageSize,
                  layout: _vm.$pageLayoutDefault,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("AlbumDownloadProgressDialog", {
        attrs: {
          visible: _vm.showDownloadProgress,
          indeterminate: "",
          percentage: _vm.downloadProgress,
          title: _vm.downloadProgressTitle,
          message: _vm.downloadProgressMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "album-heading" }, [
      _c("div", { staticClass: "album-heading__icon" }, [
        _c("i", {
          staticClass: "el-icon-picture-outline",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
      _c("div", [
        _c("span", { staticClass: "album-heading__eyebrow" }, [
          _vm._v("THƯ VIỆN ẢNH"),
        ]),
        _c("h2", { staticClass: "page-title" }, [_vm._v("Album ảnh")]),
        _c("p", { staticClass: "page-description" }, [
          _vm._v("Tìm kiếm, duyệt và quản lý toàn bộ album ảnh của trường."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "toolbar-label" }, [
      _c("i", {
        staticClass: "el-icon-s-operation",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v("Bộ lọc"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }